// German language pack
// Note: All keys are in Simplified Chinese, values are in German
// This design allows developers to use Chinese directly as keys for better understanding and maintenance

export default {
  // Computing Application Page - Computing.vue
  computing: {
    // Page titles and basic information
    '平台资产': 'Plattform-Vermögen',
    '质押金额': 'Hashrate-Betrag',
    '算力周期': 'Rechenperiode',
    '天': 'Tage',
    '算力类型': 'Rechenleistungstyp',
    '基础算力': 'Basis Computing',
    '高级算力': 'Erweiterte Computing',
    '超级算力': 'Super Computing',
    '企业算力': 'Unternehmens Computing',
    '高性能': 'Hochleistung',
    '标准': 'Standard',
    '经济型': 'Wirtschaftlich',
    '申请算力': 'Computing Beantragen',
    '申请解押': 'Hashrate-Rueckkauf',
    '可申请次数': 'Verfügbare Anträge',
    '剩余次数': 'Verbleibende Male',
    '短算力类型': 'Typ',
    '短算力周期': 'Periode',
    '短预计日收益': 'Tagesertrag',
    '短剩余次数': 'Rest',
    '短解押记录': 'Rueckkauf',
    '短算力记录': 'Leasing',
    '短质押明细': 'Hashrate',
    '短待审': 'Offen',
    '短成功': 'Erfolg',
    '短失败': 'Fehl',
    '短完成': 'Beendet',
    '超级算力申请': 'Hashrate-Leasing',

    '步骤提示租赁': 'Schritt 1 Hashrate-Plan waehlen · Schritt 2 "Hashrate-Leasing" antippen',
    '请选择算力方案': 'Bitte waehlen Sie einen Hashrate-Plan',
    '请先选择算力方案': 'Bitte zuerst einen Hashrate-Plan waehlen und dann leasen',    '算力收益等级': 'Computing-Renditestufen',
    '查看算力收益等级': 'Renditestufen Anzeigen',
    '暂无高级算力等级数据': 'Keine Daten für erweiterte Computing-Stufen verfügbar',
    '暂无超级算力等级数据': 'Keine Daten für Super-Computing-Stufen verfügbar',

    // Computing-Anwendungsdetailseite
    '算力详情': 'Computing-Details',
    '基本信息': 'Grundinformationen',
    '原押金额': 'Ursprünglicher Einsatzbetrag',
    '每日收益记录': 'Tägliche Ertragsaufzeichnungen',
    '暂无数据': 'Keine Daten Verfügbar',

    // Computing details
    '算力类型标签': 'Typ:',
    '算力周期标签': 'Periode:',
    '算力类型：': 'Typ:',
    '算力周期：': 'Periode:',
    '预计收益：': 'Erträge:',
    '质押要求：': 'Einsatz:',
    '开始时间：': 'Start:',
    '结束时间：': 'Ende:',
    '立即申请': 'Jetzt Beantragen',

    // Status and prompts
    '申请中...': 'Lädt...',
    '申请中': 'Lädt...',
    '申请成功': 'Erfolgreich',
    '申请失败': 'Fehlgeschlagen',
    '申请失败，请重试': 'Antrag fehlgeschlagen, bitte erneut versuchen',
    '余额不足': 'Guthaben zu niedrig',
    '请先连接钱包': 'Wallet verbinden',
    '算力申请成功！': 'Computing erfolgreich!',
    '算力申请失败，请重试': 'Computing fehlgeschlagen, erneut versuchen',
    '申请失败，请先解押已完成的算力订单': 'Antrag fehlgeschlagen, bitte entsperren Sie zuerst die abgeschlossene Rechenleistungsbestellung',
    'USDC': 'USDC',
    
    // Confirmation dialog
    '确认申请': 'Antrag Bestätigen',
    '取消': 'Abbrechen',
    '确认': 'Bestätigen',
    '您确定要申请此算力吗': 'Computing beantragen?',
    '您确定要申请此算力吗？': 'Computing beantragen?',
    '申请后将扣除相应的质押金额': 'Einsatzbetrag wird abgezogen',
    
    // Computing status
    '运行中': 'Läuft',
    '已完成': 'Abgeschlossen',
    '待开始': 'Ausstehend',
    '已取消': 'Abgebrochen',
    
    // Earnings related
    '预计日收益': 'Erwartete Tägliche Erträge',
    '总预计收益': 'Gesamte Erwartete Erträge',
    '当前收益': 'Aktuelle Erträge',
    
    // Records and status
    '解押申请记录': 'Rueckkaufverlauf',
    '超级算力申请记录': 'Super-Rechenleistungs-Antragsaufzeichnungen',
    '全部': 'Alle',
    '待审核': 'Ausstehend',
    '成功': 'Erfolg',
    '失败': 'Fehlgeschlagen',
    '正在加载记录': 'Aufzeichnungen werden geladen...',
    '暂无记录': 'Keine Aufzeichnungen',
    '解押金额': 'Rueckkaufbetrag',
    '申请天数': 'Antragstage',
    '金额': 'Betrag',

    // Modal related
    '选择周期': 'Ausgewählte Periode',
    '收益率': 'Rendite',
    '申请金额': 'Antragsbetrag',
    '请输入申请金额': 'Bitte geben Sie den Antragsbetrag ein',
    '最大可申请金额': 'Maximaler anwendbarer Betrag',
    '投入限额': 'Investitionslimit',
    '最低投入': 'Mindestinvestition',
    '最大投入': 'Maximale Investition',
    '短投入限额': 'Limit',
    '请输入有效的申请金额': 'Bitte geben Sie einen gültigen Antragsbetrag ein',
    '申请金额不能低于最低投入': 'Der Antragsbetrag darf nicht unter der Mindestinvestition liegen',
    '申请金额不能高于最大投入': 'Der Antragsbetrag darf die maximale Investition nicht überschreiten',

    // Error messages
    '网络错误，请稍后重试': 'Netzwerkfehler, bitte später erneut versuchen',
    '参数错误': 'Parameterfehler',
    '服务器错误': 'Serverfehler',
    '未知错误': 'Unbekannter Fehler',
    '请输入有效金额': 'Bitte geben Sie einen gültigen Betrag ein',
    '请输入大于0的解押金额': 'Bitte geben Sie einen Freigabebetrag größer als 0 ein',
    '申请提交成功': 'Antrag erfolgreich übermittelt!',
    '您的解押申请已提交，请等待审核': 'Ihr Freigabeantrag wurde übermittelt, bitte warten Sie auf die Überprüfung',
    '申请提交失败': 'Antragsübermittlung fehlgeschlagen',
    '请稍后重试': 'Bitte später erneut versuchen',
    '您的账户余额不足，无法申请算力': 'Ihr Kontoguthaben reicht nicht aus, um Rechenleistung zu beantragen',
    '您的算力申请已提交，请等待审核': 'Ihr Rechenleistungsantrag wurde übermittelt, bitte warten Sie auf die Überprüfung',
    '登录已过期': 'Anmeldung abgelaufen',
    '请重新连接钱包': 'Bitte Wallet erneut verbinden',
    '加载失败': 'Laden fehlgeschlagen',
    '无法获取解押申请记录': 'Freigabe-Antragsaufzeichnungen können nicht abgerufen werden',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'Sie haben einen ausstehenden Antrag, bitte warten Sie auf die Überprüfung, bevor Sie einen neuen Antrag einreichen',
    '您还有未解押的算力订单，无法申请新的算力': 'Sie haben eine nicht freigegebene Rechenleistungsbestellung, können keine neue Rechenleistung beantragen',
    '申请次数已用完，最大申请次数': 'Antragslimit erreicht, maximale Anträge',
    '没有可解押的金额': 'Kein Betrag zum Freigeben verfügbar',
    '您已有待处理的解押申请，请等待审核': 'Sie haben bereits einen ausstehenden Freigabantrag, bitte warten Sie auf die Überprüfung',

    '我的算力订单': 'Meine Hashrate-Aufträge',
    '总质押': 'Gesamt gestakt',
    '总收益': 'Gesamtgewinn',
    '进行中': 'Aktiv',
    '剩余天数': 'Verbleibende Tage',
    '暂无算力订单': 'Keine Hashrate-Aufträge',

    // Wallet-Verbindung bezogene Popups
    '钱包未连接': 'Wallet nicht verbunden',
    '钱包信息错误': 'Wallet-Informationsfehler',
    '钱包地址无效': 'Ungültige Wallet-Adresse',
    '授权已失效': 'Autorisierung abgelaufen',
    '授权检查失败': 'Autorisierungsprüfung fehlgeschlagen',
    '请重新授权USDC后再进行投资': 'Bitte USDC erneut autorisieren vor Investition',
    '请稍后重试或重新连接钱包': 'Bitte später versuchen oder Wallet erneut verbinden',
    '断开连接': 'Verbindung trennen',
    '质押金额不足': 'Unzureichender Einsatzbetrag',
    '解押金额不能超过当前质押金额': 'Freigabebetrag kann den aktuellen Einsatzbetrag nicht überschreiten',
    '需要连接钱包才能申请算力': 'Wallet muss verbunden werden, um Rechenleistung zu beantragen',
    '需要连接钱包才能申请解押': 'Wallet muss verbunden werden, um Freigabe zu beantragen',

    // Status-Text-Zuordnung
    '状态待审核': 'Ausstehend',
    '状态成功': 'Erfolgreich',
    '状态失败': 'Fehlgeschlagen',
    '状态进行中': 'In Bearbeitung',
    '状态已完成': 'Abgeschlossen',
    '状态已取消': 'Storniert',
    '状态未知': 'Unbekannt',

    // Wallet-Adresse bezogen
    '未连接钱包': 'Wallet nicht verbunden',
    '地址格式错误': 'Ungültiges Adressformat',

    // Kundendienst
    '客服功能开发中，敬请期待': 'Kundendienst ist in Entwicklung, bleiben Sie dran!',

    // Rechenleistungseinstellungen bezogen
    '设置错误': 'Einstellungsfehler',
    '未找到对应的算力设置': 'Rechenleistungseinstellungen nicht gefunden',
    '无法获取算力设置': 'Rechenleistungseinstellungen können nicht abgerufen werden',

    // Entsperrung bezogen (neu)
    '解押审核中': 'Entsperrung in Überprüfung',
    '已解押': 'Entsperrt',
    '确认解押': 'Entsperrung Bestätigen',
    '处理中': 'Verarbeitung...',
    '解押申请已提交': 'Entsperrungsantrag Eingereicht',
    '请等待审核处理': 'Bitte warten Sie auf die Überprüfung',
    '解押申请失败': 'Entsperrungsantrag Fehlgeschlagen',
    '当前状态不允许解押': 'Der aktuelle Status erlaubt keine Entsperrung',

    // Einsatz-Details bezogen (neu)
    '质押明细': 'Hashrate-Details',
    '后值': 'Nachwert',
    '管理员操作': 'System-Operation',
    '暂无质押记录': 'Keine Hashrate-Daten',
    '正在加载质押记录': 'Hashrate-Daten werden geladen...',
    '获取质押记录失败': 'Hashrate-Daten konnten nicht geladen werden',
    '收益': 'Ertrag',
    '质押': 'Hashrate',
    '解押': 'Rueckkauf',
    '充值': 'Einzahlung',
    '提现': 'Abhebung',
    '奖励': 'Belohnung',
    '推荐奖励': 'Empfehlungsbelohnung',
    '系统调整': 'Systemanpassung',
    '算力收益': 'Rechenleistungsertrag',
    '机器人收益': 'Bot-Ertrag',

    // Lade- und Fehlermeldungen (neu)
    '无法获取申请详情': 'Antragdetails können nicht abgerufen werden',
    '请检查网络连接后重试': 'Bitte überprüfen Sie die Netzwerkverbindung und versuchen Sie es erneut',
    '未找到可解押的算力申请': 'Keine entsperrbaren Rechenleistungsanträge gefunden',

    // Status bezogen (neu)

    // Detailseite bezogen (neu)
    '算力申请详情': 'Details des Rechenleistungsantrags',
    '算力申请记录': 'Rechenleistungsantragsaufzeichnungen',
    '正在加载详情': 'Details werden geladen...',
    '申请周期': 'Antragszeitraum',
    '申请时间': 'Antragszeit',
    '累计收益': 'Gesamtgewinne',
    '暂无收益记录': 'Keine Gewinnaufzeichnungen',
    '加载失败请重试': 'Laden fehlgeschlagen, bitte erneut versuchen',
    '重新加载': 'Neu laden',
    '包含累计收益': 'einschließlich Gesamtgewinne',
    '解押后资金将退回到平台资产中不再产生收益': 'Nach der Entsperrung werden die Mittel zu den Plattform-Assets zurückgegeben und generieren keine Gewinne mehr.',
    '申请赎回': 'Hashrate Einlösen',
    '赎回金额': 'Einlösungsbetrag',
    '赎回审核中': 'Einlösung wird geprüft',
    '未到期不可赎回': 'Vor Fälligkeit nicht einlösbar',
    '暂不可赎回': 'Noch Nicht Einlösbar',
    '当前算力未到期': 'Aktuelle Hashrate ist noch nicht fällig, Einlösung nach Fälligkeit verfügbar',
    '需要连接钱包才能申请赎回': 'Wallet verbinden, um Einlösung zu beantragen',
    '您的赎回申请已提交，请等待审核': 'Ihr Einlösungsantrag wurde eingereicht, bitte warten Sie auf die Überprüfung',
    '确认赎回': 'Einlösung bestätigen',
    '已赎回': 'Eingelöst',
    '您已有待处理的赎回申请，请等待审核': 'Sie haben bereits einen ausstehenden Einlösungsantrag, bitte warten',
    '当前状态不允许赎回': 'Aktueller Status erlaubt keine Einlösung',
    '没有可赎回的金额': 'Kein einlösbarer Betrag verfügbar'
  },

  // ==================== Vermögens-Seite - Assets.vue ====================
  assets: {
    // Gesamtvermögen
    '总资产': 'Gesamtvermögen',
    '复制成功': 'Erfolgreich kopiert',

    // Einkommensübersicht
    '总收入': 'Gesamteinkommen',
    '今日收入': 'Heutiges Einkommen',
    '体验金': 'Demo-Guthaben',
    '空投奖励': 'Airdrop-Belohnungen',

    // Aktionsschaltflächen
    '充值': 'Einzahlung',
    '快速充值说明': 'USDC schnell einzahlen',
    '提现': 'Abhebung',
    '邀请': 'Einladen',
    '白皮书': 'Whitepaper',
    '幸运轮': 'Glücksrad',
    '站内信': 'Nachrichten',
    '信用分': 'Kreditwürdigkeit',
    '快捷邀请': 'Einladen',
    '快捷白皮书': 'Whitepaper',
    '快捷幸运轮': 'Glück',
    '快捷信用分': 'Kredit',

    // VIP-Stufe
    'VIP等级': 'VIP-Stufe',
    '暂无VIP等级数据': 'Keine VIP-Stufendaten verfügbar',

    // Mein Konto
    '我的账户': 'Mein Konto',
    '申请备用金': 'Reservefonds Beantragen',
    '设置资金密码': 'Fonds-Passwort Festlegen',
    '选择语言': 'Sprache Auswählen',

    // Konsolen-Log-Nachrichten
    '钱包未连接，触发钱包连接': 'Wallet nicht verbunden, Wallet-Verbindung wird ausgelöst',
    '钱包地址无效，重新连接': 'Ungültige Wallet-Adresse, erneute Verbindung',
    '钱包已连接，直接跳转到充值页面': 'Wallet verbunden, Weiterleitung zur Einzahlungsseite',
    '检查授权状态失败': 'Überprüfung des Autorisierungsstatus fehlgeschlagen',
    '白皮书功能': 'Whitepaper-Funktion',
    '检查资金密码状态失败': 'Überprüfung des Fonds-Passwort-Status fehlgeschlagen',

    // API-bezogene Logs
    'Token不存在，显示默认余额': 'Token existiert nicht, Standardguthaben wird angezeigt',
    '调用API获取用户余额数据': 'API-Aufruf zum Abrufen der Benutzerguthaben-Daten...',
    '体验金加载成功': 'Demo-Guthaben erfolgreich geladen',
    '总资产计算完成': 'Gesamtvermögen-Berechnung abgeschlossen',
    '余额': 'Guthaben',
    '质押金额': 'Hashrate-Betrag',
    'API返回失败': 'API gab Fehler zurück',
    '加载用户余额失败': 'Laden des Benutzerguthabens fehlgeschlagen',
    'Token不存在，显示默认收益': 'Token existiert nicht, Standarderträge werden angezeigt',
    '调用API获取用户收益数据...': 'API-Aufruf zum Abrufen der Benutzerertrags-Daten...',
    '收益数据加载成功': 'Ertragsdaten erfolgreich geladen',
    '收益API返回失败': 'Ertrags-API gab Fehler zurück',
    '加载用户收益失败': 'Laden der Benutzererträge fehlgeschlagen',
    '使用默认收益数据': 'Verwendung von Standard-Ertragsdaten',
    '信用分加载成功': 'Kreditwürdigkeit erfolgreich geladen'
  },

  // ==================== Aufladeseite - Recharge.vue ====================
  recharge: {
    // Seitentitel und Navigation
    '充值': 'Aufladen',
    '返回': 'Zurück',
    '充值记录': 'Auflade-Verlauf',

    // Schritt-Titel
    '选择金额': 'Betrag auswählen',
    '确认订单': 'Bestellung bestätigen',
    '完成转账': 'Übertragung abschließen',

    // Betragseingabe
    '请输入充值金额': 'Bitte Aufladebetrag eingeben',
    '自定义': 'Benutzerdefiniert',
    '最小充值金额': 'Mindest-Aufladebetrag',
    '最小充值金额提示': 'Minimum 500 USDC',
    '最大充值金额': 'Maximal-Aufladebetrag',
    '下一步': 'Weiter',
    '上一步': 'Zurück',
    '开通自动转入': 'Auto-Transfer aktivieren',

    // Bestellinformationen
    '订单信息': 'Bestellinformationen',
    '订单号': 'Bestellnummer',
    '充值金额': 'Aufladebetrag',
    '网络': 'Netzwerk',
    '代币': 'Token',
    '收款地址': 'Empfangsadresse',
    '创建订单': 'Bestellung erstellen',
    '创建中': 'Erstellen...',

    // Wallet-Verbindung
    '请先连接钱包': 'Bitte verbinden Sie zuerst die Wallet',
    '未检测到钱包地址，请先连接钱包': 'Wallet-Adresse nicht erkannt, bitte verbinden Sie zuerst die Wallet',

    // Guthaben
    'USDC余额不足': 'Unzureichendes USDC-Guthaben! Aktuelles Guthaben',
    '转账超时，请检查钱包或重试': 'Übertragung-Timeout, überprüfen Sie die Wallet oder versuchen Sie es erneut',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': 'Übertragung erfolgreich, aber kein Transaktions-Hash erhalten, bitte geben Sie den Transaktions-Hash manuell an',
    '请先连接MetaMask钱包': 'Bitte verbinden Sie zuerst die MetaMask-Wallet',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': 'Übertragung möglicherweise erfolgreich, aber Transaktions-Hash kann nicht abgerufen werden, bitte überprüfen Sie die Wallet manuell',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': 'Transaktions-Hash ungültig, bitte kopieren Sie den korrekten Hash später aus der Wallet-Historie',
    '钱包地址不存在': 'Wallet-Adresse existiert nicht',
    '交易失败': 'Transaktion fehlgeschlagen',
    '当前网络': 'Aktuelles Netzwerk',
    '请切换到以太坊主网或测试网': 'Wechseln Sie zum Ethereum-Hauptnetz oder Testnetz',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': 'Bitte klicken Sie auf die Netzwerkeinstellungen in der oberen rechten Ecke der Seite, wählen Sie Ethereum und laden Sie dann erneut auf.',
    '需要': 'Erforderlich',
    '更新订单失败': 'Bestellung aktualisieren fehlgeschlagen',

    // Übertragungsschritte
    '请使用钱包转账': 'Bitte Wallet für Übertragung verwenden',
    '转账地址': 'Übertragungsadresse',
    '转账金额': 'Übertragungsbetrag',
    '合约地址': 'Vertragsadresse',
    '复制地址': 'Adresse kopieren',
    '复制金额': 'Betrag kopieren',
    '开始转账': 'Übertragung starten',
    '转账中': 'Übertragung läuft...',
    '重新转账': 'Übertragung wiederholen',
    '查看详情': 'Details anzeigen',

    // Statusinformationen
    '等待转账': 'Warten auf Übertragung',
    '转账状态中': 'Übertragung läuft',
    '确认中': 'Bestätigung läuft',
    '转账成功': 'Übertragung erfolgreich',
    '转账失败': 'Übertragung fehlgeschlagen',
    '交易哈希': 'Transaktions-Hash',
    '在区块链浏览器中查看': 'Im Blockchain-Explorer anzeigen',

    // Tipps
    '请确保转账金额准确': 'Bitte stellen Sie sicher, dass der Übertragungsbetrag korrekt ist',
    '请确保使用正确的网络': 'Bitte stellen Sie sicher, dass das richtige Netzwerk verwendet wird',
    '转账完成后系统会自动确认': 'Das System bestätigt automatisch nach Abschluss der Übertragung',
    '地址已复制': 'Adresse kopiert',
    '金额已复制': 'Betrag kopiert',
    '复制失败': 'Kopieren fehlgeschlagen',

    // Fehlermeldungen
    '金额不能为空': 'Betrag darf nicht leer sein',
    '金额必须大于': 'Betrag muss größer sein als',
    '金额不能超过': 'Betrag darf nicht überschreiten',
    '创建订单失败': 'Bestellung erstellen fehlgeschlagen',
    '转账失败，请重试': 'Übertragung fehlgeschlagen, bitte wiederholen',
    '网络错误，请检查连接': 'Netzwerkfehler, bitte Verbindung prüfen',

    // MetaMask相关
    '请安装MetaMask钱包': 'Bitte installieren Sie die MetaMask-Wallet',
    '网络检查通过': 'Netzwerkprüfung bestanden',
    'USDC余额不足！当前余额': 'Unzureichendes USDC-Guthaben! Aktuelles Guthaben: {balance} USDC, erforderlich: {amount} USDC',
    '余额检查通过': '✅ Guthaben-Überprüfung bestanden',
    '余额检查失败': 'Guthaben-Überprüfung fehlgeschlagen',
    '开始执行转账': '🚀 Übertragungsausführung wird gestartet...',
    '请在MetaMask中确认交易': '⏳ Bitte bestätigen Sie die Transaktion in MetaMask',
    '最终交易哈希': '✅ Finaler Transaktions-Hash',
    '交易哈希已保存到数据库': '✅ Transaktions-Hash in Datenbank gespeichert',
    '保存哈希失败': '❌ Hash-Speicherung fehlgeschlagen',
    '转账发送失败': '❌ Übertragungssendung fehlgeschlagen',
    '交易提交超时，请检查钱包交易记录或稍后重试': 'Transaktionsübermittlung-Timeout, überprüfen Sie die Wallet-Transaktionsaufzeichnungen oder versuchen Sie es später erneut',
    'Gas估算失败': 'Gas-Schätzung fehlgeschlagen',
    '交易哈希更新成功': '✅ Transaktions-Hash erfolgreich aktualisiert',
    '更新订单交易哈希失败': '❌ Aktualisierung des Bestellungs-Transaktions-Hash fehlgeschlagen',
    '启动交易监控，订单号': '🔄 Transaktionsüberwachung wird gestartet, Bestellnummer',
    '检查交易状态': '🔍 Transaktionsstatus wird überprüft...',
    '订单状态响应': '📊 Bestellstatus-Antwort',
    '订单详情': '📋 Bestelldetails',
    '交易成功': '✅ Transaktion erfolgreich!',
    '交易还在确认中，状态': '⏳ Transaktion noch in Bestätigung, Status',
    'API响应失败': '❌ API-Antwort fehlgeschlagen',
    '检查交易状态失败': 'Transaktionsstatus-Überprüfung fehlgeschlagen',
    '转账状态已重置': '🔄 Übertragungsstatus zurückgesetzt',

    // Kundendienst
    '客服功能开发中，敬请期待': 'Kundendienst-Funktion in Entwicklung, bleiben Sie dran!',

    // Rechenleistungs-Zinsstufen
    '查看算力收益等级': 'Rechenleistungs-Zinsstufen anzeigen',
    '算力收益等级': 'Rechenleistungs-Zinsstufen',
    '暂无算力收益等级数据': 'Keine Rechenleistungs-Zinsstufendaten verfügbar',
    '获取算力收益等级失败': 'Fehler beim Abrufen der Rechenleistungs-Zinsstufen',
    '日收益率': 'Tageszins'
  },

  // ==================== Aufladeverlauf-Seite - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': 'Aufladeverlauf',
    '全部': 'Alle',
    '待支付': 'Zahlung Ausstehend',
    '待审核': 'Überprüfung Ausstehend',
    '确认中': 'Bestätigung',
    '成功': 'Erfolgreich',
    '失败': 'Fehlgeschlagen',
    '已完成': 'Abgeschlossen',
    '已取消': 'Storniert',
    '暂无记录': 'Keine Aufzeichnungen',
    '加载中': 'Laden...',
    '加载更多': 'Mehr Laden',
    '没有更多数据': 'Keine weiteren Daten',
    '暂无充值记录': 'Keine Aufladeaufzeichnungen',
    '立即充值': 'Jetzt Aufladen',
    '充值': 'Aufladen',
    '订单号': 'Bestellnummer',
    '筛选': 'Filter',
    '记录': 'Eintraege',
    '总充值': 'Gesamtaufladung',
    '刚刚': 'Gerade eben',
    '分钟前': ' Minuten',
    '小时前': ' Stunden'
  },

  // ==================== Aufladedetails-Seite - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': 'Aufladedetails'
  ,

    // 新增翻译键
    '加载中': 'Laden',
    '订单不存在或已删除': 'Bestellung existiert nicht oder wurde gelöscht',
    '返回': 'Zurück',
    '订单信息': 'Bestellinformationen',
    '订单号': 'Bestellnummer',
    '充值网络': 'Aufladenetzwerk',
    '支付时间': 'Zahlungszeit',
    '确认时间': 'Bestätigungszeit',
    '转账信息': 'Überweisungsinformationen',
    '充值地址': 'Aufladeadresse',
    '复制': 'Kopieren',
    '交易哈希': 'Transaktions-Hash',
    '确认进度': 'Bestätigungsfortschritt',
    '确认': 'Bestätigung',
    '查看区块浏览器': 'Block-Explorer anzeigen',
    '取消订单': 'Bestellung stornieren'
  },

  // ==================== Auszahlungsseite - Withdrawal.vue ====================
  withdrawal: {
    // Seitentitel und Navigation
    '提现': 'Auszahlung',
    '返回': 'Zurück',
    '提现记录': 'Auszahlungshistorie',

    // Saldoanzeige
    '我的提现账户余额': 'Mein Auszahlungskonto-Saldo',
    '可提现余额': 'Verfügbarer Saldo',
    '当前可提取余额': 'Aktuell Verfügbarer Saldo',
    '信用分': 'Kredit',

    // Formularfelder
    '提现金额': 'Auszahlungsbetrag',
    '请输入提现金额': 'Bitte Auszahlungsbetrag eingeben',
    '请输入自定义提款金额': 'Bitte benutzerdefinierten Betrag eingeben',
    '最大限度': 'Max',
    '提现地址': 'Auszahlungsadresse',
    '请输入提现地址': 'Bitte Auszahlungsadresse eingeben',
    '提现密码': 'Auszahlungspasswort',
    '请输入提现密码': 'Bitte Auszahlungspasswort eingeben',
    '资金密码': 'Kapitalpasswort',
    '请输入资金密码': 'Bitte Kapitalpasswort eingeben',
    '显示密码': 'Passwort anzeigen',
    '隐藏密码': 'Passwort verbergen',

    // Auszahlungsregeln
    '提款规则': 'Auszahlungsregeln',
    '提现规则': 'Auszahlungsregeln',
    '手续费': 'Gebühr',
    '单笔范围': 'Einzelbereich',
    '提现手续费': 'Auszahlungsgebühr',
    '提现金额范围': 'Auszahlungsbetragsbereich',
    '资金将在1-24小时内到账': 'Geld kommt in 1-24 Stunden an',
    '手续费率': 'Gebührensatz',
    '最小提现金额': 'Mindestabhebung',
    '最大提现金额': 'Maximale Abhebung',
    '预计到账时间': 'Erwartete Ankunftszeit',
    '工作日内处理': 'Bearbeitung an Werktagen',

    // Schaltflächen und Aktionen
    '确认提款': 'Auszahlung bestätigen',
    '处理中': 'Verarbeitung',
    '提交申请': 'Antrag einreichen',
    '设置资金密码': 'Kapitalpasswort festlegen',
    '忘记密码？': 'Passwort vergessen?',
    '取消': 'Abbrechen',
    '去设置': 'Zu Einstellungen',

    // Modale Eingabeaufforderungen
    '需要设置资金密码': 'Kapitalpasswort muss festgelegt werden',
    '为了您的资金安全，请先设置资金密码': 'Für Ihre Kapitalsicherheit, bitte zuerst Kapitalpasswort festlegen',

    // Erfolgsmeldungen
    '申请提交成功': 'Antrag erfolgreich eingereicht',
    '您的提现申请已提交，请等待审核': 'Ihr Auszahlungsantrag wurde eingereicht, bitte warten Sie auf die Prüfung',
    '提现申请已提交': 'Auszahlungsantrag eingereicht',
    '请等待审核': 'Bitte warten Sie auf die Prüfung',

    // Fehlermeldungen
    '申请提交失败': 'Antragstellung fehlgeschlagen',
    '提现申请失败': 'Auszahlungsantrag fehlgeschlagen',
    '请稍后重试': 'Bitte später erneut versuchen',
    '余额不足': 'Guthaben zu niedrig',
    '金额格式错误': 'Ungültiges Betragsformat',
    '地址格式错误': 'Ungültiges Adressformat',
    '资金密码错误': 'Falsches Kapitalpasswort',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'Sie haben bereits einen ausstehenden Auszahlungsantrag, bitte warten Sie auf die Bearbeitung, bevor Sie einen neuen einreichen',
    '信用分不足': 'Unzureichende Kreditwürdigkeit',
    '信用分不足无法提款': 'Unzureichende Kreditwürdigkeit, Auszahlung nicht möglich',
    '您有待还款订单，请还款后申请提现': 'Sie haben ausstehende Darlehensaufträge. Bitte zahlen Sie zurück, bevor Sie eine Auszahlung beantragen!',

    // Systemnachrichten und Logs
    '用户提现申请': 'Benutzer-Auszahlungsantrag',
    '加载用户数据失败': 'Laden der Benutzerdaten fehlgeschlagen',
    '检查资金密码状态失败': 'Überprüfung des Kapitalpasswort-Status fehlgeschlagen'
  },



  // ==================== Einladungsmodal - InviteModal.vue ====================
  invite: {
    '邀请好友一起赚币': 'Freunde zum Verdienen einladen',
    '复制邀请码': 'Einladungscode kopieren',
    '朋友扫二维码注册加入': 'Freunde scannen QR-Code zur Registrierung',
    '邀请链接': 'Einladungslink',
    '加载邀请数据失败': 'Fehler beim Laden der Einladungsdaten',
    '加载失败': 'Laden fehlgeschlagen',
    '获取邀请信息失败，请稍后重试': 'Fehler beim Abrufen der Einladungsinfos, bitte später versuchen',
    '生成二维码失败': 'Fehler beim Generieren des QR-Codes',
    '邀请码已复制': 'Einladungscode kopiert',
    '邀请链接已复制': 'Einladungslink kopiert',
    '复制失败': 'Kopieren fehlgeschlagen',
    '请手动复制': 'Bitte manuell kopieren'
  },

  // ==================== Glücksrad-Seite - LuckyWheel.vue ====================
  luckyWheel: {
    '幸运轮': 'Glücksrad',
    '页面副标题': 'Raster-Ziehung · laufendes Licht',
    '剩余': 'Verbleibend',
    '次': 'mal',
    '奖金': 'Preis',
    '抽奖': 'Ziehen',
    '奖品': 'Preis',
    '暂无中奖记录': 'Keine Gewinnaufzeichnungen',
    '总抽奖次数': 'Gesamtziehungen',
    '抽奖次数不足': 'Unzureichende Ziehungen',
    '提示': 'Hinweis',
    '抽奖失败': 'Ziehung fehlgeschlagen',
    '网络错误': 'Netzwerkfehler',
    '网络错误，请重试': 'Netzwerkfehler, bitte versuchen Sie es erneut',
    '中奖时间': 'Gewinnzeit',
    '中奖金额': 'Gewinnbetrag',
    '状态': 'Status',
    '暂无数据': 'Keine Daten',
    '待发放': 'Ausstehend',
    '已发放': 'Ausgezahlt',
    '发放失败': 'Fehlgeschlagen',
    '恭喜中奖': 'Herzlichen Glückwunsch!',
    '确定': 'OK'
  },

  // ==================== Mittel beantragen - ApplyFunds.vue ====================
  applyFunds: {
    '申请备用金': 'Mittel beantragen',
    '经平台审核，您可向平台申请一笔借款': 'Nach Plattformprüfung können Sie ein Darlehen beantragen',
    '借贷产品': 'Darlehensprodukt',
    '请选择产品': 'Bitte Produkt auswählen',
    '借款金额': 'Darlehensbetrag',
    '输入借款金额': 'Darlehensbetrag eingeben',
    '还款周期': 'Rückzahlungszeitraum',
    '请输入还款周期': 'Rückzahlungszeitraum eingeben',
    '天': 'Tage',
    '日利率': 'Tageszins',
    '利息': 'Zinsen',
    '还款方式': 'Rückzahlungsart',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Kostenloser Service von HamiltonLane, bitte mit externen Mitteln zurückzahlen',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Kostenloser Service von HamiltonLane, bitte mit externen Mitteln zurückzahlen',
    '放款机构': 'Kreditgeber',
    '借款规则': 'Darlehensregeln',
    '下一步': 'Weiter',
    '姓名': 'Name',
    '手机号': 'Telefon',
    '证件上传': 'Dokumenten-Upload',
    '身份证正面': 'Ausweis Vorderseite',
    '身份证反面': 'Ausweis Rückseite',
    '点击上传': 'Zum Hochladen klicken',
    '重新上传': 'Erneut hochladen',
    '上传成功': 'Upload erfolgreich',
    '上传失败': 'Upload fehlgeschlagen',
    '请上传身份证正面': 'Bitte laden Sie die Vorderseite des Ausweises hoch',
    '请上传身份证反面': 'Bitte laden Sie die Rückseite des Ausweises hoch',
    '请输入': 'Bitte eingeben',
    '提交中': 'Wird eingereicht...',
    '确定': 'Bestätigen',
    '请选择图片文件': 'Bitte waehlen Sie eine Bilddatei aus',
    '文件大小不能超过10MB': 'Die Dateigroesse darf 10MB nicht ueberschreiten',
    '恭喜您申请成功': 'Herzlichen Glückwunsch zur erfolgreichen Bewerbung',
    '您的借款已申请成功，待平台审核成功放款': 'Ihr Darlehensantrag war erfolgreich, wartet auf Plattformgenehmigung',
    '选择借贷产品': 'Darlehensprodukt auswählen',

    // Fehlermeldungen
    '申请失败': 'Antrag Fehlgeschlagen',
    '申请失败，请重试': 'Antrag fehlgeschlagen, bitte versuchen Sie es erneut',

    // Produktnamen-Übersetzungen
    '产品名称': {
      '快速借贷': 'Schnellkredit',
      '标准借贷': 'Standardkredit',
      '长期借贷': 'Langzeitkredit',
      '小额借贷': 'Mikrokredit',
      '大额借贷': 'Großkredit',
      '短期借贷产品': 'Kurzzeitkredit-Produkt'
    },

    // Produktbeschreibungs-Übersetzungen
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Geeignet für kurzfristige Kapitalumschläge, vorteilhafte Zinssätze, schnelle Genehmigung'
    },

    // API-Nachrichten-Übersetzungen
    'API消息': {
      '获取借贷产品成功': 'Kreditprodukte erfolgreich abgerufen'
    }
  },

  // ==================== Darlehensaufzeichnungen - LoanRecords.vue ====================
  loanRecords: {
    '借款记录': 'Darlehensaufzeichnungen',
    '借贷中心': 'Darlehenszentrum',
    '总记录': 'Gesamtaufzeichnungen',
    '总借款': 'Gesamtdarlehen',
    '进行中': 'Laufend',
    '全部': 'Alle',
    '加载中': 'Wird geladen',
    '没有更多数据了': 'Keine weiteren Daten',
    '借款': 'Darlehen',
    '借款金额': 'Darlehensbetrag',
    '还款周期': 'Rückzahlungszeitraum',
    '天': 'Tage',
    '日利率': 'Tageszins',
    '利息': 'Zinsen',
    '还款方式': 'Rückzahlungsart',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Kostenloser Service von HamiltonLane, bitte mit externen Mitteln zurückzahlen',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Kostenloser Service von HamiltonLane, bitte mit externen Mitteln zurückzahlen',
    '放款机构': 'Kreditgeber',
    '待审核': 'Ausstehend',
    '已通过': 'Genehmigt',
    '审核成功': 'Genehmigt',
    '已驳回': 'Abgelehnt',
    '审核失败': 'Abgelehnt',
    '已还款': 'Zurückgezahlt',
    '已逾期': 'Überfällig',
    '逾期': 'Überfällig',
    '未知状态': 'Unbekannter Status'
  },

  // ==================== Kapitalpasswort festlegen - SetFundPassword.vue ====================
  setFundPassword: {
    '设置资金密码': 'Kapitalpasswort festlegen',
    '安全中心': 'Sicherheitszentrum',
    '密码长度至少6位': 'Passwort muss mindestens 6 Zeichen haben',
    '密码长度不超过20位': 'Passwort darf nicht mehr als 20 Zeichen haben',
    '确认密码': 'Passwort bestätigen',
    '两次输入的密码一致': 'Passwörter stimmen überein',
    '设置中': 'Wird festgelegt...',
    '确定': 'Bestätigen',

    // API-Antwortnachrichten
    '参数验证失败': 'Parametervalidierung fehlgeschlagen',
    '您已设置过资金密码，如需修改请联系客服': 'Sie haben bereits ein Kapitalpasswort festgelegt. Bitte kontaktieren Sie den Kundendienst für Änderungen',
    '资金密码设置成功': 'Kapitalpasswort erfolgreich festgelegt',
    '设置失败': 'Festlegung fehlgeschlagen',
    '获取状态失败': 'Status konnte nicht abgerufen werden',

    // Frontend-Eingabenachrichten
    '设置成功': 'Erfolgreich festgelegt',
    '请稍后重试': 'Bitte versuchen Sie es später erneut',
    '设置资金密码失败': 'Kapitalpasswort konnte nicht festgelegt werden'
  },

  // ==================== Kapitalpasswort ändern - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // Seitentitel
    '修改资金密码': 'Kapitalpasswort ändern',
    '修改安全密码': 'Sicherheitspasswort ändern',
    '返回': 'Zurück',

    // Statusanzeige
    '已设置资金密码': 'Kapitalpasswort wurde festgelegt',

    // Formularfelder
    '原密码': 'Aktuelles Passwort',
    '请输入原密码': 'Bitte aktuelles Passwort eingeben',
    '新密码': 'Neues Passwort',
    '请输入新密码': 'Bitte neues Passwort eingeben',
    '确认新密码': 'Neues Passwort bestätigen',
    '请再次输入新密码': 'Bitte neues Passwort erneut eingeben',

    // Schaltflächen und Aktionen
    '确认修改': 'Änderung bestätigen',
    '修改中': 'Wird geändert...',
    '忘记原密码': 'Aktuelles Passwort vergessen?',
    '忘记安全密码': 'Sicherheitspasswort vergessen?',
    '联系客服': 'Support kontaktieren',
    '取消': 'Abbrechen',

    // Hinweise
    '原密码不能为空': 'Aktuelles Passwort darf nicht leer sein',
    '原密码错误': 'Aktuelles Passwort ist falsch',
    '新密码不能与原密码相同': 'Neues Passwort darf nicht mit dem aktuellen identisch sein',
    '密码修改成功': 'Passwort erfolgreich geändert',
    '密码修改失败': 'Passwort-Änderung fehlgeschlagen',
    '如需重置安全密码，请联系客服人员协助处理': 'Um Ihr Sicherheitspasswort zurückzusetzen, wenden Sie sich bitte an den Kundendienst',

    // API-Antwortnachrichten
    '参数验证失败': 'Parametervalidierung fehlgeschlagen',
    '您尚未设置资金密码': 'Sie haben noch kein Kapitalpasswort festgelegt',
    '资金密码修改成功': 'Kapitalpasswort erfolgreich geändert',
    '修改失败': 'Änderung fehlgeschlagen',

    // Frontend-Eingabenachrichten
    '修改安全密码失败': 'Sicherheitspasswort konnte nicht geändert werden',
    '请稍后重试': 'Bitte versuchen Sie es später erneut'
  ,

    // 新增翻译键
    '密码长度6-20位': 'Passwort-Länge 6-20 Zeichen',
    '两次输入的密码一致': 'Passwörter stimmen überein'
  },

  // ==================== Robot-Investment-Seite - RobotInvestment.vue ====================
  robotInvestment: {
    // Seitentitel
    '详情': 'Details',
    '返回': 'Zurück',

    // Kaufinformationen
    '申购金额': 'Kaufbetrag',
    '购买金额': 'Kaufbetrag',
    '最大': 'Max',
    '最小限额': 'Mindestgrenze',
    '最大限额': 'Höchstgrenze',
    '日收益率': 'Tägliche Rendite',
    '周期': 'Zeitraum',
    '天': 'Tage',

    // Saldoinformationen
    '可用余额': 'Verfügbares Guthaben',
    '可购次数': 'Anzahl Käufe',

    // Schaltflächen und Status
    '处理中': 'Verarbeitung',
    '申购': 'Kaufen',
    '余额错误': 'Guthabenfehler',
    '无法获取有效的余额信息': 'Gueltiges Guthaben konnte nicht abgerufen werden',
    '输入错误': 'Eingabefehler',
    '请输入申购金额': 'Bitte Kaufbetrag eingeben',
    '请输入有效的申购金额': 'Bitte gueltigen Kaufbetrag eingeben',
    '钱包未连接': 'Wallet nicht verbunden',
    '请先连接钱包': 'Bitte zuerst Wallet verbinden',
    '钱包信息错误': 'Wallet-Informationsfehler',
    '请重新连接钱包': 'Bitte Wallet erneut verbinden',
    '钱包地址无效': 'Ungueltige Wallet-Adresse',
    '授权已失效': 'Autorisierung abgelaufen',
    '请重新授权USDC后再进行投资': 'Bitte USDC erneut autorisieren, bevor Sie investieren',
    '授权检查失败': 'Autorisierungspruefung fehlgeschlagen',
    '请稍后重试或重新连接钱包': 'Bitte spaeter erneut versuchen oder Wallet neu verbinden',
    '金额不足': 'Betrag zu niedrig',
    '申购金额不能少于': 'Kaufbetrag darf nicht kleiner sein als',
    '金额超限': 'Betrag ueber Limit',
    '申购金额不能超过': 'Kaufbetrag darf nicht groesser sein als',
    '余额不足': 'Unzureichendes Guthaben',
    '您的可用余额为': 'Ihr verfuegbares Guthaben ist',
    '无法完成此次申购': 'dieser Kauf kann nicht abgeschlossen werden',
    '申购成功': 'Kauf erfolgreich',
    '订单号': 'Bestellnummer',
    '申购失败': 'Kauf fehlgeschlagen',
    '申购失败，请稍后重试': 'Kauf fehlgeschlagen, bitte spaeter erneut versuchen',
    '网络错误，请稍后重试': 'Netzwerkfehler, bitte spaeter erneut versuchen'
  },

  // ==================== Flash Options - FlashOptions.vue ====================
  flashOptions: {
    '闪电期权': 'Flash-Optionen',
    '请先连接钱包': 'Bitte Wallet verbinden',
    '连接钱包后即可开始闪电期权交易': 'Verbinden Sie Ihr Wallet, um mit Flash-Optionen zu handeln',
    '连接钱包': 'Wallet verbinden',
    '加载中': 'Laden...',
    '暂无可交易资产': 'Keine handelbaren Vermögenswerte',
    '请稍后再试': 'Bitte versuchen Sie es später',
    '时间': 'Zeit',
    '金额': 'Betrag',
    '回报额': 'Rendite',
    '利润': 'Gewinn',
    '当前持仓': 'Offene Positionen',
    '暂无持仓': 'Keine Positionen',
    '买涨': '▲ Hoch',
    '买跌': '▼ Runter',
    '开仓': 'Eröffnung',
    '入场价': 'Einstiegspreis',
    '出场价': 'Ausstiegspreis',
    '收益率': 'Rendite',
    '投入': 'Betrag',
    '入场时间': 'Einstiegszeit',
    '出场时间': 'Ausstiegszeit',
    '实时价': 'Live-Preis',
    '倒计时': 'Countdown',
    '交易记录': 'Handelshistorie',
    '暂无记录': 'Keine Einträge',
    '涨': 'Hoch',
    '跌': 'Runter',
    '秒': 's',
    '分钟': 'Min',
    '结算中': 'Abrechnung...',
    '加载配置失败': 'Laden fehlgeschlagen',
    '请完善交易信息': 'Bitte vervollständigen Sie die Angaben',
    '下单失败': 'Bestellung fehlgeschlagen',
    '买涨成功': 'Kauf Hoch erfolgreich',
    '买跌成功': 'Kauf Runter erfolgreich',
    '等待行情数据': 'Warte auf Marktdaten...',
    '余额不足': 'Unzureichendes Guthaben',
    '资产不可用': 'Asset nicht verfügbar',
    '周期不可用': 'Zeitraum nicht verfügbar',
    '智能交易': 'KI-Handel',
    '交易标的': 'Asset',
    '风险类型': 'Risikotyp',
    '投入金额': 'Betrag',
    '提交申请': 'Absenden',
    '我的AI订单': 'Meine KI-Orders',
    '稳健型': 'Konservativ',
    '平衡型': 'Ausgewogen',
    '进取型': 'Aggressiv',
    '稳健': 'Sicher',
    '平衡': 'Ausgewogen',
    '进取': 'Aggressiv',
    '低风险低回报适合稳健投资者': 'Niedriges Risiko, niedrige Rendite. Für konservative Anleger.',
    '中等风险中等回报适合大多数投资者': 'Mittleres Risiko, mittlere Rendite. Für die meisten Anleger.',
    '高风险高回报适合激进投资者': 'Hohes Risiko, hohe Rendite. Für aggressive Anleger.',
    '待审核': 'Ausstehend',
    '运行中': 'Läuft',
    '已停止': 'Gestoppt',
    '已结算': 'Abgerechnet',
    '已驳回': 'Abgelehnt',
    'AI剩余': 'Verbleibend',
    'AI做单': 'Trades',
    'AI笔': '',
    'AI胜': 'G',
    'AI负': 'V',
    '请先选择交易标的': 'Bitte wählen Sie ein Asset',
    '请输入有效金额': 'Bitte geben Sie einen gültigen Betrag ein',
    'AI交易申请已提交': 'KI-Handel eingereicht, Überprüfung ausstehend',
    'AI提交失败': 'Einreichung fehlgeschlagen',
    '停止交易': 'Stoppen',
    '确认停止AI交易': 'AI-Handel stoppen? Restguthaben wird erstattet.',
    '停止失败': 'Stoppen fehlgeschlagen',
    '确认取消AI申请': 'AI-Antrag stornieren? Eingefrorene Mittel werden erstattet.',
    '取消失败': 'Stornierung fehlgeschlagen',
    '体验金': 'Demo',
    '体验金不足': 'Unzureichendes Demo-Guthaben',
    '可用余额': 'Verfüg.',
    '累计盈亏': 'PnL',
  },

  // ==================== Untere Navigation - BottomNavigation.vue ====================
  bottomNav: {
    '首页': 'Start',
    '投资': 'Investieren',
    '算力申请': 'Wealth',
    '闪期权': 'Flash',
    '资产': 'Profil'
  },

  // ==================== Kontoänderungsaufzeichnungen - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': 'Kontoänderungsaufzeichnungen',
    '总收入': 'Gesamteinkommen',
    '总支出': 'Gesamtausgaben',
    '净收益': 'Nettogewinn',
    '记录总数': 'Gesamtanzahl Aufzeichnungen',
    '全部': 'Alle',
    '用户充值': 'Benutzer-Aufladung',
    '管理操作': 'System-Operation',
    '用户提现': 'Benutzer-Abhebung',
    '借贷': 'Darlehen',
    '借贷到账': 'Darlehen Gutgeschrieben',
    '算力申请': 'Rechenleistungs-Antrag',
    '机器人收益': 'Roboter-Erträge',
    '算力收益': 'Rechenleistungs-Erträge',
    '空投': 'Airdrop',
    '幸运轮': 'Glücksrad',
    '闪期权': 'Flash-Optionen',
    '加载中': 'Wird geladen',
    '暂无记录': 'Keine Aufzeichnungen',
    '暂无账变记录': 'Keine Kontoänderungsaufzeichnungen',
    '余额变化': 'Saldoänderung',
    '加载更多': 'Mehr laden',
    '记录详情': 'Aufzeichnungsdetails',
    '业务类型': 'Geschäftstyp',
    '操作类型': 'Operationstyp',
    '变动金额': 'Änderungsbetrag',
    '变动前余额': 'Saldo vor Änderung',
    '变动后余额': 'Saldo nach Änderung',
    '变动原因': 'Änderungsgrund',
    '备注': 'Bemerkung',
    '状态': 'Status',
    '交易哈希': 'Transaktions-Hash',
    '创建时间': 'Erstellungszeit',
    '处理时间': 'Bearbeitungszeit',
    '刚刚': 'Gerade eben',
    '分钟前': 'Minuten her',
    '小时前': 'Stunden her',
    '关闭': 'Schließen',
    '没有更多记录': 'Keine weiteren Aufzeichnungen',

    // Geschäftstypen (einige Schlüssel existieren bereits, kommentiert um Duplikate zu vermeiden)
    // '充值': 'Aufladen',
    // '提现': 'Abhebung',
    // '算力申请': 'Rechenleistung', // Doppelter Schlüssel, bereits anderswo definiert
    'AI机器人': 'KI-Roboter',
    '解押': 'Rueckkauf',
    '管理员操作': 'System-Operation',
    '推荐佣金': 'Empfehlungsprovision',
    // '奖励': 'Belohnung',
    '幸运轮盘': 'Glücksrad',
    '其他': 'Andere',

    // Status
    '待审核': 'Überprüfung ausstehend',
    '处理中': 'In Bearbeitung',
    '待处理': 'Ausstehend',
    '已完成': 'Abgeschlossen',
    '失败': 'Fehlgeschlagen',
    '已取消': 'Abgebrochen',

    // Aktionstypen
    '增加': 'Hinzufügen',
    '减少': 'Reduzieren',
    '设置': 'Setzen',

    // Kontotypen
    '余额变动': 'Saldoänderung',
    '质押变动': 'Einsatzänderung',

    // Grund-Übersetzungen
    'reason_recharge_arrived': 'Aufladung Angekommen',
    'reason_withdrawal_apply': 'Abhebungsantrag, Saldo Gefroren',
    'reason_withdrawal_rejected': 'Abhebungsantrag Abgelehnt, Gefrorener Saldo Zurückgegeben',
    'reason_withdrawal_success': 'Abhebung Erfolgreich',
    'reason_computing_apply': 'Rechenleistungsantrag, Saldo Gefroren',
    'reason_unstake_success': 'Freigabe Erfolgreich, Einsatz Aufgetaut zum Saldo',
    'reason_computing_earning': 'Rechenleistungserträge Angekommen',
    'reason_computing_unstake': 'Rechenleistung Abgelaufen Freigabe',
    'reason_robot_invest': 'KI-Roboter-Investition',
    'reason_robot_earning': 'Robotererträge Angekommen',
    'reason_loan_credit': 'Darlehensgenehmigung gutgeschrieben',
    'reason_unstake_approved': 'Freigabeantrag Genehmigt',
    'reason_referral_commission': 'Empfehlungsprovision Angekommen',
    'reason_lucky_wheel_reward': 'Glücksrad-Preisbelohnung',
    'reason_airdrop': 'Airdrop-Belohnung',
    'reason_reward': 'Belohnungsverteilung',
    'reason_airdrop_issue': 'Airdrop-Ausschüttung',
    'reason_flash_option_buy': 'Flash-Option Bestellung',
    'reason_flash_option_win': 'Flash-Option Gewinn',
    'reason_flash_option_draw': 'Flash-Option Unentschieden Rückerstattung',
    'reason_flash_option_lose': 'Flash-Option Verlust',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',

    // Bemerkung-Übersetzungen
    'remark_recharge_order': 'Aufladungsbestellung',
    'remark_withdrawal_order': 'Abhebungsbestellung',
    'remark_application_rejected': 'Antrag Abgelehnt',
    'remark_transaction_hash': 'Transaktions-Hash',
    'remark_computing_application': 'Rechenleistungsantrag',
    'remark_unstake_application': 'Freigabeantrag',
    'remark_robot_order': 'Roboterbestellung',
    'remark_lucky_wheel_reward': 'Glücksrad-Belohnung',
    'remark_robot_earning': 'Robotererträge',
    'remark_computing_earning': 'Rechenleistungserträge',
    'remark_computing_earning_to_stake': 'Rechenleistungserträge zum Stake hinzugefügt',
    'remark_flash_option_buy': 'Flash-Option Bestellung',
    'remark_flash_option_win': 'Flash-Option Gewinn',
    'remark_flash_option_draw': 'Flash-Option Unentschieden Rückerstattung',
    'remark_flash_option_lose': 'Flash-Option Verlust',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Airdrop-Ausschüttung',

    '闪期权下单': 'Flash-Option Bestellung',
    '闪期权盈利': 'Flash-Option Gewinn',
    '闪期权平局': 'Flash-Option Unentschieden',
    '闪期权亏损': 'Flash-Option Verlust',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Airdrop-Ausschüttung',
    '算力收益发放': 'Rechenleistungserträge Ausschüttung',
    '奖励发放': 'Prämienausschüttung',
    '成功': 'Erfolgreich',
    '资产中心': 'Asset-Zentrum',
    '筛选': 'Filtern',
    '更多类型': 'Mehr Typen',
    '金额方向': 'Betragsrichtung',
    '流入': 'Zufluss',
    '流出': 'Abfluss',
    '关键词': 'Schlüsselwort',
    '搜索类型原因备注': 'Typ/Grund/Notiz suchen',
    '重置': 'Zurücksetzen',
    '完成': 'Fertig',
    '当前筛选': 'Aktueller Filter',
    '记录条数': 'Einträge',
    '净额': 'Netto',
    '点击查看详情': 'Tippen für Details',
    '账变记录页面已加载': 'Seite für Kontoveränderungen geladen'
  },

  // ==================== Startseite - Home.vue ====================
  home: {
    // Hauptinhalt
    'titleLine1': 'HamiltonLane',
    'titleLine2': 'Private Markets. Professional Allocation.',
    'mainTitle': 'HamiltonLane: Private Markets Investment Solutions',
    'mainDescription': 'We partner with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios—helping every investor access quality opportunities worldwide.',
    'heroIntro': 'A professional investment platform built for high-net-worth clients',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',
    'startJoining': 'Get Started',
    'walletConnected': 'Wallet verbunden',
    'walletNotConnected': 'Wallet nicht verbunden',
    'heroMarketTag': 'Private Markets',

    // Investitionsbereich
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',

    // Kategorie-Inhalte
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',

    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',

    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',

    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',

    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',

    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',

    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',

    // Allgemein
    'more': 'Mehr',
    'collapse': 'Einklappen',

    // Ertragsbereich
    'earningsTitle': 'Performance',

    // Firmenvorstellung
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane ist ein globales Hochtechnologieunternehmen mit Hauptsitz in Singapur, das gemeinsam von Bitmain, A*STAR Institute of High Performance Computing (IHPC) und Core Scientific, Inc. gegründet wurde...',
    'companyFull': 'HamiltonLane ist ein globales Hochtechnologieunternehmen mit Hauptsitz in Singapur, das gemeinsam von Bitmain, A*STAR Institute of High Performance Computing (IHPC) und Core Scientific, Inc. gegründet wurde. Das Unternehmen konzentriert sich auf die tiefe Integration von künstlicher Intelligenz (KI) und Blockchain-Technologie und ist bestrebt, weltweit führende Kryptowährungs-Rechenleistungssysteme und intelligente Rechenleistungs-Ökosystem-Infrastrukturen aufzubauen, um die nachhaltige Entwicklung der neuen Generation intelligenter Wirtschaft voranzutreiben. Als innovatives Unternehmen, das gemeinsam von drei Institutionen mit globalem Einfluss in ihren jeweiligen Bereichen gegründet wurde, vereint HamiltonLane die zentralen technologischen Vorteile von Bitmain im Blockchain-Chip-Design und Rechenleistungs-Hardware, die internationale Forschungsstärke von IHPC in Hochleistungsrechnen und KI-Algorithmus-Optimierung sowie die führende Erfahrung von Core Scientific im Blockchain-Infrastrukturbau und Rechenzentrumsbetriebs. Die synergistische Zusammenarbeit der drei Parteien ermöglicht es HamiltonLane, starke technologische Integrationsfähigkeiten und globale Ressourcenallokationsfähigkeiten zu besitzen und eine solide Grundlage für die effiziente, sichere und intelligente Entwicklung von Rechenleistungsnetzwerken zu schaffen. Das von HamiltonLane unabhängig entwickelte dezentralisierte intelligente Rechenleistungssystem (Decentralized Intelligent Computing Network, DICN) integriert KI-Rechenleistungsplanung, Blockchain-Smart-Contracts und Hochleistungsrechentechnologie, um automatisiertes Management und Ertragsoptimierung von Rechenleistungsressourcen zu realisieren. Das System kann netzwerkübergreifende Rechenleistungsallokation, Echtzeitüberwachung und Energieeffizienzoptimierung in Multi-Chain-Ökosystemen realisieren und die Rechenleistungsnutzung und Gesamtertragseffizienz erheblich verbessern. Gleichzeitig kann das System durch Deep Learning und Vorhersagemodelle von KI-Algorithmen automatische Risikoidentifikation, Markttrendanalyse und dynamische Ressourcenplanung realisieren und globalen Benutzern transparente, sichere und intelligente Rechenleistungsservice-Erfahrungen bieten. Das Geschäftssystem von HamiltonLane umfasst KI-Rechenleistungsnetzwerkbau, Blockchain-Rechenleistungsmanagement, Cloud-Hochleistungsrechnen, Datenverschlüsselung und Datenschutz sowie On-Chain-Ertragsinvestitionssysteme. Das Unternehmen fördert aktiv die Anwendung von KI-Rechenleistung in den Branchen dezentralisierte Finanzen (DeFi), Web3.0, Cloud Computing und wissenschaftliches Rechnen und baut vollständige Rechenleistungslösungen von der Basis-Hardware bis zu Ökosystemen der oberen Ebene auf. Mit der Entwicklungsphilosophie "Intelligence Empowers the Future" nimmt HamiltonLane technologische Innovation als zentrale Triebkraft und Compliance, Sicherheit und Transparenz als Betriebsprinzipien an und ist bestrebt, globalen Institutionen und Einzelinvestoren integrierte Rechenleistungs-Asset-Management- und KI-gesteuerte Investitionslösungen zu bieten. Durch die gemeinsame technologische und industrielle Zusammenarbeit von Bitmain, IHPC und Core Scientific beschleunigt HamiltonLane den Aufbau eines globalen intelligenten Rechenleistungs-Infrastrukturnetzwerks und wird zu einer wichtigen Brücke, die künstliche Intelligenz und Blockchain-Wirtschaft verbindet, und bietet solide Rechenleistungsunterstützung und strategische Triebkraft für globale Digitalisierungs- und Intelligentisierungsprozesse.',
    'persistentLink': 'Mehr über Persistent Systems erfahren',
    'tradingBotsLink': 'Visit Website',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',

    // FAQ
    'faqTitle': 'Häufig gestellte Fragen',
    'faq1Question': 'What does HamiltonLane provide?',
    'faq1Answer': 'We provide private markets investment solutions—partnering with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios, and helping investors access related opportunities worldwide.',
    'faq2Question': 'Who is the platform for?',
    'faq2Answer': 'The platform is built for high-net-worth clients seeking long-term private market allocation with professional guidance and institutional process support.',
    'faq3Question': 'How do I get started?',
    'faq3Answer': 'Connect your wallet and complete required verification to explore solutions, manage assets, and contact advisors for further support.',

    // Partner-Plattformen
    'partnerTitle': 'Partners',

    // Kundendienst
    'customerServiceDevelopment': 'Kundendienst ist in Entwicklung, bleiben Sie dran!'
  },

  // ==================== Darlehensregeln Seite - LoanRules.vue ====================
  loanRules: {
    '借款规则': 'Darlehensregeln',
    '人工智能算力贷款协议说明': 'Beschreibung des KI-Rechenleistungs-Darlehensvertrags',
    '协议前言': 'Angesichts der guten Transaktionshistorie von Partei A stimmt Partei B zu, diesen "KI-Rechenleistungs-Darlehensvertrag" mit Partei A auf der Grundlage von Freiwilligkeit, Gleichberechtigung und gegenseitigem Einverständnis zu unterzeichnen. Beide Parteien sollten diesen Vertrag sorgfältig lesen, ihre jeweiligen Rechte und Pflichten klären und bei der Förderung und Standardisierung von gewinnbringenden Aktivitäten im Zusammenhang mit KI-Rechenleistung zusammenarbeiten.',
    '贷款金额及抵押物要求': '1. Darlehensbetrag und Sicherheitenanforderungen',
    '贷款额度说明': 'Partei B wird ein Darlehenslimit von 5.000 bis 50.000 USDC basierend auf den Transaktionsaufzeichnungen und dem Kreditstatus von Partei A im crypto.com-Konto bereitstellen. Dieses Limit kann mehrfach beantragt werden, und der endgültig genehmigte Betrag unterliegt den Bewertungsergebnissen des Plattformsystems.',
    '贷款期限': 'Darlehenslaufzeit',
    '期限说明': 'Die Laufzeit des Darlehens unter diesem Vertrag beträgt 7 Tage, 15 Tage oder 30 Tage, die von Partei B vor der Kreditvergabe basierend auf dem Antrag und den Plattformbewertungsergebnissen unabhängig ausgewählt und bestimmt wird und zum Zeitpunkt der Kreditvergabe bestätigt wird.',
    '资金要求': 'Partei A muss sicherstellen, dass die Mittel und verfügbaren Krypto-Assets in ihrem Konto ausreichend sind, um die Anforderungen der Darlehensgenehmigung und Risikokontrolle zu erfüllen.',
    '审批流程': 'Vor der Mittelauszahlung muss Partei A den von Partei B formulierten Darlehensgenehmigungsprozess abschließen, einschließlich aber nicht beschränkt auf Kreditstatusbewertung und Mittelflussüberprüfung.',
    '资金使用': '2. Mittelverwendung',
    '使用限制': 'Die von Partei B ausgezahlten Darlehensmittel sind auf Investitionen in KI-Agent-Rechenleistung beschränkt und dürfen nicht für andere Zwecke verwendet werden.',
    '使用规定': 'Partei A muss die relevanten Vorschriften zur Verwendung von Darlehensmitteln strikt einhalten und sollte Partei B innerhalb einer angemessenen Frist nach Erhalt der Mittel wie erforderlich Anweisungen zur Mittelverwendung zur Verfügung stellen, um die Einhaltung der Mittelverwendung sicherzustellen.',
    '借款与还款说明': '3. Darlehens- und Rückzahlungsanweisungen',
    '借款还款规定': 'Darlehensmittel sind strikt auf die Teilnahme am HamiltonLane Super Computing Pool beschränkt und dürfen nicht für andere Zwecke verwendet werden. Die Darlehenslaufzeit wird mit dem verbleibenden Betriebszyklus des Super Computing Pools übereinstimmen, an dem der Benutzer (Partei A) teilnimmt. Alle Darlehen müssen innerhalb von 24 Stunden vor Ende des Computing Pool-Zyklus vollständig zurückgezahlt werden. Eine verspätete Rückzahlung führt zu Verzugsgebühren und Strafgebühren gemäß den relevanten Bedingungen. Der Darlehensnehmer (Partei A) muss seinen Finanzplan vernünftig organisieren, um eine pünktliche Erfüllung sicherzustellen.',
    '借款须知': '4. Darlehenshinweis',
    '身份验证要求': 'Alle Darlehensanträge müssen gültige Identitätsdokumente und Informationen zum Wohngebiet einreichen und hochladen. Dies zielt darauf ab, die Identitätsverifikation und Compliance-Überprüfung abzuschließen, um sicherzustellen, dass der Darlehensprozess sicher, transparent und den regulatorischen Anforderungen entspricht. Das System wird Benutzerinformationen unter strengen Datenverschlüsselungs- und Datenschutzmechanismen speichern und überprüfen, die nur für die Bewertung der Darlehensberechtigung und das Risikomanagement verwendet werden und nicht für andere Zwecke verwendet werden. Antragsteller müssen sicherstellen, dass die bereitgestellten Informationen wahr und genau sind, um eine Beeinträchtigung der Darlehensprüfung und des nachfolgenden Mittelauszahlungsfortschritts zu vermeiden.'
  },

  // ==================== Obere Kopfzeile - TopHeader.vue ====================
  topHeader: {
    '选择网络': 'Netzwerk auswählen',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Anmeldung läuft',
    '连接钱包': 'Wallet verbinden',
    '连接中': 'Verbindung...',
    '已连接': 'Verbunden',
    '连接成功': 'Verbindung erfolgreich!',
    '钱包已成功连接': 'Wallet erfolgreich verbunden',
    '钱包信息': 'Wallet-Informationen',
    '钱包地址': 'Wallet-Adresse',
    '断开连接': 'Trennen',
    '已断开连接': 'Getrennt',
    '正在初始化': 'Initialisierung...',
    '正在切换网络': 'Netzwerk wechseln...',
    '登录完成': 'Anmeldung abgeschlossen',
    '请在钱包中确认': 'Bitte in der Wallet bestätigen...',
    '登录成功': 'Anmeldung erfolgreich',

    // Wallet-Verbindungsfehlermeldungen
    '钱包连接失败': 'Wallet-Verbindung fehlgeschlagen',
    '未知错误': 'Unbekannter Fehler',
    '认证失败，请重试连接钱包': 'Authentifizierung fehlgeschlagen, bitte versuchen Sie die Wallet-Verbindung erneut',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'Wallet-Verbindungsanfrage wird verarbeitet, bitte warten oder Seite aktualisieren und erneut versuchen',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Wallet-Verbindungsanfrage steht aus, bitte in Ihrer Wallet bestätigen',
    '授权失败': 'Autorisierung fehlgeschlagen',
    '交易被撤销，可能是合约错误或余额不足': 'Transaktion rückgängig gemacht, möglicherweise aufgrund von Vertragsfehler oder unzureichendem Guthaben',

    // Wallet-Verbindungsstatus-Nachrichten
    '欢迎！您的账户已创建成功': 'Willkommen! Ihr Konto wurde erfolgreich erstellt',
    '钱包连接成功': 'Wallet erfolgreich verbunden',
    '钱包已断开连接': 'Wallet getrennt',
    '是否断开钱包连接？': 'Wallet-Verbindung trennen?',

    '确定': 'OK',

    // 新增的翻译键 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': 'Wallet nicht verbunden, bitte verbinden Sie zuerst die Wallet',
    '中文（简体）': 'Chinesisch (Vereinfacht)',
    '用户取消了授权': 'Benutzer hat die Autorisierung abgebrochen',
    'ETH余额不足，无法支付Gas费用': 'Unzureichendes ETH-Guthaben, kann Gas-Gebühren nicht bezahlen',
    'Gas费用设置过低': 'Gas-Gebühren zu niedrig eingestellt',
    '交易nonce错误，请重试': 'Transaktions-Nonce-Fehler, bitte erneut versuchen',
    'Gas价格过低，请提高Gas价格': 'Gas-Preis zu niedrig, bitte erhöhen Sie den Gas-Preis',
    '合约参数错误，请检查网络和合约地址': 'Vertragsparameter-Fehler, bitte überprüfen Sie Netzwerk und Vertragsadresse',
    '余额不足，无法完成授权': 'Unzureichendes Guthaben, kann Autorisierung nicht abschließen',
    '请安装 MetaMask 或其他以太坊钱包': 'Bitte installieren Sie MetaMask oder eine andere Ethereum-Wallet',
    '请安装 TronLink 钱包': 'Bitte installieren Sie die TronLink-Wallet',
    '未找到授权目标地址，请先获取系统配置': 'Autorisierungs-Zieladresse nicht gefunden, bitte holen Sie zuerst die Systemkonfiguration',
    '获取授权地址失败': 'Fehler beim Abrufen der Autorisierungsadresse',
    '不支持的网络类型': 'Nicht unterstützter Netzwerktyp',
    '网络切换可能未完成，当前链ID': 'Netzwerkwechsel möglicherweise nicht abgeschlossen, aktuelle Chain-ID',
    '请刷新页面重试': 'Bitte aktualisieren Sie die Seite und versuchen Sie es erneut',
    '网络连接失败': 'Netzwerkverbindung fehlgeschlagen',
    '授权地址格式错误': 'Autorisierungsadresse-Format falsch',
    '合约地址格式错误': 'Vertragsadresse-Format falsch',
    'ETH余额不足！当前余额': 'Unzureichendes ETH-Guthaben! Aktuelles Guthaben',
    '需要': 'Erforderlich',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Wallet-Verbindungsanfrage steht aus, bitte in MetaMask bestätigen',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Wallet-Verbindungsanfrage steht aus, bitte in Trust Wallet bestätigen',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Wallet-Verbindungsanfrage steht aus, bitte in Coinbase Wallet bestätigen'
  },

  // ==================== Wallet-Informationen - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': 'Wallet-Adresse in die Zwischenablage kopiert',
    '钱包信息已刷新': 'Wallet-Informationen aktualisiert',
    '钱包信息已刷新（自动重连成功）': 'Wallet-Informationen aktualisiert (automatische Wiederverbindung erfolgreich)',
    '登录已过期，请重新连接钱包': 'Anmeldung abgelaufen, bitte Wallet erneut verbinden',
    '刷新失败': 'Aktualisierung fehlgeschlagen',
    '交易历史功能开发中': 'Transaktionsverlauf-Funktion in Entwicklung',
    '确定要断开钱包连接吗': 'Sind Sie sicher, dass Sie die Wallet-Verbindung trennen möchten?',
    '钱包已断开连接': 'Wallet getrennt',
    '断开连接失败': 'Trennung fehlgeschlagen',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': 'Sind Sie sicher, dass Sie die Sammel-Funktion testen möchten? Dies überprüft, ob Ihre Wallet Sammel-Operationen durchführen kann',
    '归集测试完成': 'Sammel-Test abgeschlossen',
    '归集测试失败': 'Sammel-Test fehlgeschlagen',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': 'Sind Sie sicher, dass Sie ETH sammeln möchten? Dies überträgt ETH von Ihrer Wallet zur Sammel-Adresse',
    'ETH归集成功': 'ETH-Sammlung erfolgreich',
    'ETH归集失败': 'ETH-Sammlung fehlgeschlagen'
  },

  // ==================== Auszahlungsverlauf Seite - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': 'Auszahlungsverlauf',
    '全部': 'Alle',
    '待审核': 'Ausstehend',
    '处理中': 'Verarbeitung',
    '已完成': 'Abgeschlossen',
    '失败': 'Fehlgeschlagen',
    '已取消': 'Storniert',
    '正在加载记录': 'Datensätze werden geladen',
    '暂无记录': 'Keine Datensätze',
    '链类型': 'Chain-Typ',
    '提现时间': 'Auszahlungszeit',
    '操作时间': 'Operationszeit',
    '订单号': 'Bestellnummer',
    '提现金额': 'Auszahlungsbetrag',
    '手续费': 'Gebühr',
    '实际金额': 'Tatsächlicher Betrag',
    '实际到账': 'Tatsächlich erhalten',
    '提现地址': 'Auszahlungsadresse',
    '转账Hash': 'Transfer-Hash',
    '交易Hash': 'Transaktions-Hash',
    '备注': 'Bemerkung',
    '提现详情': 'Auszahlungsdetails',
    '基本信息': 'Grundinformationen',
    '状态': 'Status',
    '金额信息': 'Betragsinformationen',
    '地址信息': 'Adressinformationen',
    '时间信息': 'Zeitinformationen',
    '处理时间': 'Verarbeitungszeit',
    '地址已复制': 'Adresse kopiert',
    'Hash已复制': 'Hash kopiert',
    '复制失败': 'Kopieren fehlgeschlagen',
    '请手动复制': 'Bitte manuell kopieren',
    '获取提现记录失败': 'Abrufen der Auszahlungsdatensätze fehlgeschlagen',
    '加载提现记录失败': 'Laden der Auszahlungsdatensätze fehlgeschlagen',
    '筛选': 'Filter',
    '记录数': 'Eintraege',
    '提现总额': 'Gesamtauszahlung'
  },

  // Investitionsseite - Investment.vue
  investment: {
    'AI机器人列表': 'KI-Roboter-Liste',
    '正在加载机器人列表': 'Roboter-Liste wird geladen...',
    '已连接': 'Verbunden',
    '活跃': 'Aktiv',
    '可用': 'Verfügbar',
    '最小金额': 'Mindestbetrag',
    '日利率': 'Tageszins',
    '当前利率': 'Aktueller Zinssatz',
    '利率等级': 'Zinsstufen',
    '查看利率等级': 'Zinsstufen anzeigen',
    '暂无利率等级数据': 'Keine Zinsstufendaten verfügbar',
    '投资期': 'Investitionszeitraum',
    '天': 'Tage',
    '关联机器人': 'Roboter Verbinden',
    '查看机器人': 'Roboter Anzeigen',
    '处理中': 'Verarbeitung...',
    '关联机器人确认': 'Roboter-Verbindungsbestätigung',
    '投资金额': 'Investitionsbetrag',
    '最小投资': 'Mindestinvestition',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Hinweis: Jeder Benutzer kann nur einen Roboter verbinden. Nach der Verbindung wird Ihr gesamtes aktuelles Guthaben für die Investition verwendet.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'Sie haben bereits andere aktive Roboter-Bestellungen. Bitte warten Sie, bis die aktuelle Bestellung beendet ist, bevor Sie einen neuen Roboter verbinden.',
    '关联中': 'Verbindung...',
    '确认关联': 'Verbindung Bestätigen',
    '取消': 'Abbrechen',
    '获取机器人列表失败': 'Fehler beim Abrufen der Roboter-Liste',
    '获取机器人列表失败，请稍后重试': 'Fehler beim Abrufen der Roboter-Liste, bitte später versuchen',
    '获取机器人列表错误': 'Fehler beim Abrufen der Roboter-Liste',
    '请先连接钱包': 'Bitte zuerst Wallet verbinden',
    '钱包信息错误，请重新连接钱包': 'Wallet-Informationsfehler, bitte Wallet erneut verbinden',
    '钱包地址无效，请重新连接钱包': 'Ungültige Wallet-Adresse, bitte Wallet erneut verbinden',
    '未授权，直接触发USDC授权流程': '❌ Nicht autorisiert, USDC-Autorisierungsprozess wird ausgelöst',
    'USDC授权检查通过，显示关联确认弹窗': '✅ USDC-Autorisierungsprüfung bestanden, Verbindungsbestätigungsdialog wird angezeigt',
    '关联机器人失败': 'Roboter-Verbindung fehlgeschlagen',
    '授权检查失败，请重新连接钱包后重试': 'Autorisierungsprüfung fehlgeschlagen, bitte Wallet erneut verbinden und versuchen',
    '关联机器人失败，请稍后重试': 'Roboter-Verbindung fehlgeschlagen, bitte später versuchen',
    '机器人信息不存在': 'Roboter-Informationen existieren nicht',
    '准备关联弹窗失败': 'Fehler beim Vorbereiten des Verbindungsdialogs',
    '获取用户信息失败，请重试': 'Fehler beim Abrufen der Benutzerinformationen, bitte versuchen Sie es erneut',
    '检查其他活跃订单失败': 'Fehler beim Überprüfen anderer aktiver Bestellungen',
    '获取余额失败': 'Fehler beim Abrufen des Guthabens',
    '获取用户余额失败': 'Fehler beim Abrufen des Benutzerguthabens',
    '从localStorage获取余额失败': 'Fehler beim Abrufen des Guthabens aus localStorage',
    '您的余额不足最小投资金额': 'Ihr Guthaben {balance} USDC reicht nicht für den Mindestinvestitionsbetrag {minAmount} USDC',
    '自动关联机器人创建的订单': 'Bestellung durch automatische Roboter-Verbindung erstellt',
    '创建订单失败': 'Fehler beim Erstellen der Bestellung',
    '正在打开AI助手聊天窗口...': 'KI-Assistent-Chat-Fenster wird geöffnet...',
    '客服功能开发中，敬请期待！': 'Kundenservice-Funktion in Entwicklung, bleiben Sie dran!',
    '投资页面已加载': 'Investitionsseite geladen',
  
    'AI多元化投资': 'KI-Diversifizierte Investments',
    'AI驱动的数字资产研究平台': 'KI-gestuetzte Forschungsplattform fuer digitale Assets',
    '正在加载': 'Wird geladen...',
    '暂无记录': 'Keine Eintraege',
    '终端标题': 'KI INVESTMENT TERMINAL',
},

  // ==================== Roboter-Details-Seite - RobotDetails.vue ====================
  robotDetails: {
    // Seitentitel
    'AI机器人详情': 'KI-Roboter-Details',

    // Statistiken
    '投资期': 'Investitionszeitraum',
    '日利率': 'Tageszins',
    '当前投资金额': 'Aktueller Investitionsbetrag',
    '余额': 'Guthaben',
    '体验金': 'Demo-Guthaben',
    '天': 'Tage',

    // Ertragsaufzeichnungen
    '加载收益记录...': 'Ertragsaufzeichnungen werden geladen...',
    '暂无收益记录': 'Keine Ertragsaufzeichnungen',
    '关联机器人后次日开始计算收益': 'Erträge werden ab dem nächsten Tag nach Roboter-Verbindung berechnet',
    '您已关联其他机器人': 'Sie haben bereits einen anderen Roboter verbunden',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Jeder Benutzer kann nur einen Roboter verbinden, bitte beenden Sie zuerst die aktuelle Roboter-Investition',
    '加载更多': 'Mehr laden',
    '加载中': 'Lädt...',

    // Zeitanzeige
    '今天': 'Heute',
    '昨天': 'Gestern',

    // Status
    '待发放': 'Ausstehend',
    '已发放': 'Ausgezahlt',
    '发放失败': 'Auszahlung fehlgeschlagen',
    '未知': 'Unbekannt',

    // Fehlermeldungen
    '未找到机器人信息': 'Roboter-Informationen nicht gefunden',
    '暂无描述': 'Keine Beschreibung',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Momentum-Strategie fuer wichtige Krypto-Assets',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Grid-Strategie fuer volatile Maerkte',
    '未知机器人': 'Unbekannter Roboter',
  
    'heroTitle': 'NEXT-GEN KI-ROBOTER',
    'heroSubtitle': 'Signal-Engine · Auto-Rebalance · Smarte Abwehr',
},

  // ==================== Bestellungen-Seite - Orders.vue ====================
  orders: {
    // Seitentitel
    '我的订单': 'Meine Bestellungen',

    // Filter-Tabs
    '全部': 'Alle',
    '进行中': 'Laufend',
    '已完成': 'Abgeschlossen',

    // Ladezustand
    '正在加载订单列表...': 'Bestellliste wird geladen...',

    // Bestelldetails
    '订单号': 'Bestellnr.',
    '投资金额': 'Investitionsbetrag',
    '日收益': 'Tägliche Erträge',
    '投资期': 'Investitionszeitraum',
    '天': 'Tage',
    '已获收益': 'Gesamterträge',
    '进度': 'Fortschritt',
    '剩余': 'Verbleibend',
    '查看详情': 'Details anzeigen',

    // Leerer Zustand
    '暂无订单': 'Keine Bestellungen',
    '您还没有任何机器人投资订单': 'Sie haben noch keine Roboter-Investitionsaufträge',
    '去投资': 'Investieren gehen',

    // Mehr laden
    '加载中': 'Lädt...',
    '加载更多': 'Mehr laden',

    // Fehlermeldungen
    '获取订单列表失败': 'Bestellliste konnte nicht abgerufen werden',
    '获取订单列表失败，请稍后重试': 'Bestellliste konnte nicht abgerufen werden, bitte später erneut versuchen',
    '获取订单列表错误': 'Fehler beim Abrufen der Bestellliste',
    '登录已过期，请重新连接钱包': 'Anmeldung abgelaufen, bitte Wallet erneut verbinden',

    // Konsolen-Logs
    '订单页面已加载': 'Bestellseite geladen'
  },

  // ==================== Erträge-Seite - Earnings.vue ====================
  earnings: {
    // Seitentitel
    '收益记录': 'Ertragsaufzeichnungen',

    // Filter-Tabs
    '全部': 'Alle',
    '日收益': 'Tägliche Erträge',
    '奖励': 'Belohnungen',
    '推荐': 'Empfehlung',

    // Ladezustand
    '正在加载收益记录...': 'Ertragsaufzeichnungen werden geladen...',

    // Ertragsdetails
    '机器人': 'Roboter',
    '订单号': 'Bestellnr.',
    '收益日期': 'Ertragsdatum',
    '说明': 'Beschreibung',

    // Leerer Zustand
    '暂无收益记录': 'Keine Ertragsaufzeichnungen',
    '您还没有任何收益记录': 'Sie haben noch keine Ertragsaufzeichnungen',
    '去投资': 'Investieren gehen',

    // Mehr laden
    '加载中': 'Lädt...',
    '加载更多': 'Mehr laden',

    // Fehlermeldungen
    '获取收益统计失败': 'Ertragsstatistiken konnten nicht abgerufen werden',
    '获取收益记录失败': 'Ertragsaufzeichnungen konnten nicht abgerufen werden',
    '获取收益记录失败，请稍后重试': 'Ertragsaufzeichnungen konnten nicht abgerufen werden, bitte später erneut versuchen',
    '获取收益记录错误': 'Fehler beim Abrufen der Ertragsaufzeichnungen',
    '登录已过期，请重新连接钱包': 'Anmeldung abgelaufen, bitte Wallet erneut verbinden',

    // Konsolen-Logs
    '收益记录页面已加载': 'Ertragsseite geladen'
  },

  // ==================== Computing-Anwendungen-Seite - ComputingApplications.vue ====================
  computingApplications: {
    // Seitentitel und Tabs
    '解押申请记录': 'Rueckkaufverlauf',
    '超级算力申请记录': 'Super-Computing-Anträge',
    '短解押记录': 'Rueckkauf',
    '短算力记录': 'Leasing',

    // Status-Filter
    '全部': 'Alle',
    '待审核': 'Ausstehend',
    '成功': 'Erfolgreich',
    '失败': 'Fehlgeschlagen',
    '短全部': 'Alle',
    '短待审': 'Offen',
    '短成功': 'Erfolg',
    '短失败': 'Fehl',
    '短完成': 'Fertig',
    '短未知': 'Unbek.',

    // Ladezustand
    '正在加载申请记录': 'Antragsaufzeichnungen werden geladen...',
    '正在加载申请记录...': 'Antragsaufzeichnungen werden geladen...',

    // Antragsdetails
    '申请天数': 'Antragstage',

    // Leerer Zustand
    '暂无申请记录': 'Keine Antragsaufzeichnungen',

    // Mehr laden
    '加载中': 'Lädt...',
    '加载更多': 'Mehr laden',

    // Aktionen
    '确定要取消这个申请吗？': 'Sind Sie sicher, dass Sie diesen Antrag stornieren möchten?',
    '申请已取消': 'Antrag storniert',
    '取消申请失败，请稍后重试': 'Antrag konnte nicht storniert werden, bitte später erneut versuchen',

    // Fehlermeldungen
    '获取申请列表失败': 'Antragsliste konnte nicht abgerufen werden',
    '获取申请列表失败，请稍后重试': 'Antragsliste konnte nicht abgerufen werden, bitte später erneut versuchen',
    '获取申请列表错误': 'Fehler beim Abrufen der Antragsliste',
    '获取失败': 'Abruf fehlgeschlagen',
    '登录过期': 'Anmeldung abgelaufen',
    '登录已过期，请重新连接钱包': 'Anmeldung abgelaufen, bitte Wallet erneut verbinden',
    '取消申请失败': 'Antrag konnte nicht storniert werden',

    // Status-Text
    '进行中': 'Laufend',
    '已完成': 'Abgeschlossen',
    '已取消': 'Storniert',
    '未知': 'Unbekannt',

    // Konsolen-Logs
    '算力申请记录页面已加载': 'Computing-Anwendungsseite geladen'
  },

  // ==================== Whitepaper-Seite - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': 'Whitepaper',
    '正在加载白皮书': 'Whitepaper wird geladen',
    '加载失败': 'Laden fehlgeschlagen',
    '重试': 'Wiederholen',
    '在新窗口打开': 'In neuem Fenster öffnen',
    '下载PDF': 'PDF herunterladen'
  },

  // ==================== Airdrop-Belohnungen Seite - AirdropRewards.vue ====================
  airdropRewards: {
    // Seitentitel
    '空投奖励': 'Airdrop-Belohnungen',
    '返回': 'Zurück',

    // Statistiken
    '累计获得 (USDC)': 'Gesamt Erhalten (USDC)',
    '待发放数量': 'Ausstehende Anzahl',
    '待发放金额 (USDC)': 'Ausstehender Betrag (USDC)',

    // Filter-Tabs
    '全部': 'Alle',
    '待发放': 'Ausstehend',
    '已发放': 'Verteilt',

    // Statustext
    '已取消': 'Storniert',
    '发放失败': 'Verteilung Fehlgeschlagen',
    '失败': 'Fehlgeschlagen',
    '未知': 'Unbekannt',

    // Zeitbezogen
    '发放时间': 'Verteilungszeit',

    // Ladezustände
    '加载中': 'Wird geladen...',
    '加载更多': 'Mehr laden...',
    '没有更多数据了': 'Keine weiteren Daten',
    '暂无空投奖励记录': 'Keine Airdrop-Belohnungsaufzeichnungen',

    // Belohnungsinformationen
    '总奖励': 'Gesamtbelohnungen',
    '今日奖励': 'Heutige Belohnungen',
    '待领取': 'Ausstehend',
    '已领取': 'Beansprucht',

    // Belohnungsliste
    '奖励记录': 'Belohnungsaufzeichnungen',
    '奖励类型': 'Belohnungstyp',
    '奖励金额': 'Belohnungsbetrag',
    '获得时间': 'Erhaltene Zeit',
    '领取状态': 'Anspruchsstatus',
    '领取': 'Beanspruchen',

    // Belohnungstypen
    '注册奖励': 'Registrierungsbelohnung',
    '邀请奖励': 'Empfehlungsbelohnung',
    '活动奖励': 'Ereignisbelohnung',
    '签到奖励': 'Check-in-Belohnung',
    '推广奖励': 'Werbebelohnung',

    // Aktionstipps
    '领取成功': 'Erfolgreich beansprucht',
    '领取失败': 'Anspruch fehlgeschlagen',
    '暂无奖励记录': 'Keine Belohnungsaufzeichnungen',
    '全部领取': 'Alle Beanspruchen'
  },

  about: {
    'pageTitle': 'About HamiltonLane',
    'subtitle': 'A U.S. private markets investment solutions provider',
    'companyIntro': 'Company Overview',
    'companyIntroP1': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally.',
    'companyIntroP2': 'The company offers investment solutions across a range of private markets. As a professional investment platform built for high-net-worth clients, we remain committed to delivering quality service and quality investment opportunities.',
    'statYears': 'Private Markets Focus',
    'statClients': 'Clients Served',
    'statCountries': 'Markets Covered',
    'statEmployees': 'Specialist Team',
    'ourMission': 'Our Mission',
    'missionInnovation': 'Professional Solutions',
    'missionInnovationDesc': 'Deliver institutional-grade private market fund and direct investment solutions',
    'missionPartnership': 'Client Partnership',
    'missionPartnershipDesc': 'Build and manage portfolios side by side with clients from conception to monitoring',
    'missionGlobalImpact': 'Global Access',
    'missionGlobalImpactDesc': 'Help every investor reach private market opportunities worldwide',
    'ourServices': 'Our Services',
    'serviceAI': 'Portfolio Conception',
    'serviceAIDesc': 'Co-design objectives and strategies for private market allocation',
    'serviceBlockchain': 'Funds & Direct Deals',
    'serviceBlockchainDesc': 'Structure private market funds and construct direct investment portfolios',
    'serviceCloud': 'Portfolio Management',
    'serviceCloudDesc': 'Continuously manage holdings with performance tracking and refinement',
    'serviceData': 'Risk Monitoring',
    'serviceDataDesc': 'Monitor risk with disciplined processes for transparency and control'
  },

  notFound: {
    'title': 'Seite nicht gefunden',
    'description': 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    'goHome': 'Zur Startseite',
    'goBack': 'Zurueck'
  },

  translationTest: {
    'pageTitle': 'Uebersetzungstest',
    'currentLanguage': 'Aktuelle Sprache',
    'selectLanguage': 'Sprache waehlen',
    'balanceInsufficient': 'Unzureichendes Guthaben',
    'fundPasswordError': 'Fonds-Passwortfehler',
    'submitFailed': 'Einreichung fehlgeschlagen',
    'pendingWithdrawal': 'Ausstehender Auszahlungsantrag',
    'langZh': 'Chinesisch',
    'langEn': 'Englisch',
    'langIt': 'Italienisch',
    'langFr': 'Franzoesisch',
    'langDe': 'Deutsch',
    'langEs': 'Spanisch',
    'langPt': 'Portugiesisch',
    'langPl': 'Polnisch',
    'langTr': 'Tuerkisch',
    'mockTestTitle': 'Simulierter Fehlertest',
    'testFundPasswordError': 'Fonds-Passwort-Uebersetzung testen',
    'testDirect': 'Direkte Uebersetzung testen',
    'original': 'Originalmeldung',
    'translated': 'Nach Uebersetzung',
    'direct': 'Direkte Uebersetzung'
  },

  iconTest: {
    'pageTitle': 'Icon-Test',
    'crypto': 'Crypto.com',
    'binance': 'Binance',
    'okx': 'OKX',
    'bitget': 'Bitget',
    'lbank': 'LBank',
    'kucoin': 'KuCoin',
    'kraken': 'Kraken',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': 'Bybit',
    'huobi': 'Huobi',
    'coinbase': 'Coinbase',
    'default': 'Standard-Icon'
  },

  // ==================== Nachrichtenseite - Messages.vue ====================
  messages: {
    '站内信': 'Nachrichten',
    'messageCenter': 'Nachrichtenzentrum',
    'title': 'Nachrichten',
    'total': 'Gesamt',
    'unread': 'Ungelesen',
    'statusNew': 'NEU',
    'statusRead': 'GELESEN',
    'noDataAlt': 'Keine Daten',
    '暂无消息': 'Keine Nachrichten',
    '加载中': 'Wird geladen...',
    '加载更多': 'Mehr laden',
    '删除': 'Löschen',
    '删除成功': 'Erfolgreich gelöscht',
    '删除失败': 'Fehler beim Löschen',
    '确定删除吗': 'Sind Sie sicher, dass Sie löschen möchten?',
    '昨天': 'Gestern',
    'closeButton': 'Schliessen'
  },

  // ==================== Allgemeine Übersetzungen ====================
  common: {
    '加载中': 'Wird geladen...',
    '加载更多': 'Mehr laden',
    '删除': 'Löschen',
    '删除成功': 'Erfolgreich gelöscht',
    '删除失败': 'Fehler beim Löschen',
    '确定删除吗': 'Sind Sie sicher, dass Sie löschen möchten?',
    '昨天': 'Gestern',
    '查看全部': 'Alle anzeigen',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Online-Support',
    '在线': 'Online',
    '输入消息...': 'Nachricht eingeben...',
    '输入消息占位': 'Nachricht eingeben...',
    '发送': 'Senden',
    '客服欢迎语': 'Hallo, hier ist der Online-Support. Wie koennen wir Ihnen helfen?',
    '客服自动回复提现': 'Ihre Auszahlungsanfrage wurde erhalten. Bitte senden Sie die Auftragsnummer zur priorisierten Pruefung.',
    '客服自动回复充值': 'Ihre Einzahlungsanfrage wurde erhalten. Bitte senden Sie Coin, Netzwerk und Auftragsnummer.',
    '客服自动回复密码': 'Senden Sie aus Sicherheitsgruenden kein Fonds-Passwort im Chat. Wir fuehren Sie durch sichere Schritte.',
    '客服自动回复默认': 'Ihre Nachricht ist eingegangen. Der Support bearbeitet sie, bitte warten Sie kurz.',
    '仅支持图片文件': 'Nur Bilddateien werden unterstuetzt.',
    '图片大小不能超过5MB': 'Die Bildgroesse darf 5MB nicht ueberschreiten.'
  },

  creditScore: {
    'pageTitle': 'Kredit-Score',
    'overview': 'Kredituebersicht',
    'composition': 'Score-Aufteilung',
    'factorStability': 'Kontostabilitaet',
    'factorBehavior': 'Kapitalverhalten',
    'factorRisk': 'Risikokontrollverlauf',
    'adviceTitle': 'Kreditempfehlungen',
    'tip1': 'Halten Sie den Kontostand stabil und bleiben Sie aktiv, um den Score zu verbessern.',
    'tip2': 'Reduzieren Sie ungewoehnlich haeufige grosse Transfers, um Risikoschwankungen zu senken.',
    'tip3': 'Optimieren Sie Sicherheitseinstellungen, um die Konto-Vertrauensstufe zu erhoehen.',
    'levelAPlus': 'A+ Exzellent',
    'levelA': 'A Stabil',
    'levelB': 'B Gut',
    'levelC': 'C Beobachten',
    'levelD': 'D Risiko'
  }

}
